/**
 * Show a list view in an operations context of all the device groups of
 * type 'factoryfixture_devicegroup'
 */
import Radio from 'backbone.radio';
import FactoryDevicegroupItemView from '@/views/list_item/factory_device_group';
import Button from '@/views/button';
import ListView from '@/views/modules/list_view';
import EmptyView from '@/views/factory_list_empty_view';

    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');
    var apiCh = Radio.channel('api');

    var DG_TYPE = 'factoryfixture_devicegroup';

    function show_factory_devicegroups(product) {
        let active_account = globalCh.request('active_account');
        let primary_account = globalCh.request('primary_account');

        var app_container = globalCh.request('app_layout');


        let enabled =  active_account.permits(primary_account, 'create_factory_devicegroup');
        var create_button = Button.extend({
            text: 'Create New Fixture Group',
            icon: 'fa fa-plus-circle',
            primary: true,
            enabled: enabled,
            enabled_tooltip: 'Create a new Fixture Device Group',
            disabled_tooltip: 'A Product must have at least one Production Device Group & at least one DUT Device Group to create a Fixture Device Group',
            action: function() {
                globalCh.request('show_create_factory_device_group_dialog', product, DG_TYPE);
            }
        });

        let container_view = new ListView({
            title: 'Fixture Device Groups',
            request_data: {
                'filter[product.id]': product.id,
                'filter[type]': DG_TYPE,
                'include': 'current_deployment,production_target,production_target.current_deployment,dut_target,dut_target.current_deployment',
                'page[size]': 15,
                'sort': '-deployment'
            },
            empty_view: EmptyView,
            child_view: FactoryDevicegroupItemView.extend({expandable: true}),
            create_button: create_button,
            type: DG_TYPE,
            product: product
        });

        app_container.showChildView('container', container_view);

        product.counts.fetch();
        let prod_target_count = 0;
        let dut_target_count = 0;

        let _prod_targets = apiCh.request('production_devicegroup').fetch(
            { data: 
                {
                    'filter[product.id]' : product.id,
                    'filter[type]': 'production_devicegroup'
                }
            }).then(function(resp) {
                prod_target_count = resp.data && resp.data.length;
                if ( prod_target_count > 0 && dut_target_count > 0 && enabled === true ) {
                    container_view.getChildView('create_button').enable();
                } else {
                    container_view.getChildView('create_button').disable();
                }
            });
        let _dut_targets = apiCh.request('dut_devicegroup').fetch(
            { data: 
                {
                    'filter[product.id]' : product.id,
                    'filter[type]': 'dut_devicegroup'
                }
            }).then(function(resp) {
                dut_target_count = resp.data && resp.data.length;
                if ( prod_target_count > 0 && dut_target_count > 0 && enabled === true ) {
                    container_view.getChildView('create_button').enable();
                } else {
                    container_view.getChildView('create_button').disable();
                }
        });
        
        // Here and below is our normal navigation stuff

        // Breadcrumb Menu
        globalCh.request('set_selection', {
            type: 'factory',
            id: product.id,
            v5_object: product,
            area: 'production'
        });

        // Left Nav
        globalCh.request(
            'show_production_zone_secondary_nav',
            product,
            { selected: 'factory-devicegroups' }
        );

        // Router
        routerCh.request(
            'set_location',
            'product_devicegroups',
            product,
            'factory_devicegroup');
    }
    export default show_factory_devicegroups;

